import { Logger } from '@tools/logger/logger';
import { hideSubmitLoader, showSubmitLoader } from '@atoms/spinner';

export class Onboarding {
  /**
   * Onboarding management
   * @param URLCallback
   */
  constructor(URLOnboardingUpdate) {
    this.highlightedDOMElement = document.querySelector('.onboarding-highlight');
    this.contextDOMElement = document.querySelector('.onboarding');
    this.gotItDOMElement = this.contextDOMElement.querySelector('.onboarding-content__gotit');
    this.closeDOMElement = this.contextDOMElement.querySelector('.onboarding-content__close');
    this.URLOnboardingUpdate = URLOnboardingUpdate;
    this.startCallback = null;
    this.endCallback = null;
  }

  init() {
    if (typeof this.startCallback === 'function') {
      this.startCallback();
    }
    Onboarding.toggleOnboarding();
    this.gotItDOMElement.addEventListener('click', () => this.onboardingDone());
    this.closeDOMElement.addEventListener('click', () => this.closeAndDoneOnboarding());
  }

  static toggleOnboarding() {
    document.body.classList.toggle('no-scroll');
  }

  removeMarkup() {
    this.contextDOMElement.parentNode.removeChild(this.contextDOMElement);
    if (this.highlightedDOMElement) {
      this.highlightedDOMElement.classList.remove('onboarding-highlight');
    }
  }

  onboardingDone() {
    const submitButton = this.contextDOMElement.querySelector('.btn');
    showSubmitLoader(submitButton);

    fetch(this.URLOnboardingUpdate)
      .then(() => {
        Onboarding.toggleOnboarding();
        this.removeMarkup();
        if (typeof this.endCallback === 'function') {
          this.endCallback();
        }
      })
      .catch((error) => {
        Logger.error(error);
      })
      .finally(() => {
        hideSubmitLoader(submitButton);
      });
  }

  closeAndDoneOnboarding() {
    this.removeMarkup();
    if (typeof this.endCallback === 'function') {
      this.endCallback();
    }

    fetch(this.URLOnboardingUpdate)
      .then(() => {
        Onboarding.toggleOnboarding();
      })
      .catch((error) => {
        Logger.error(error);
      });
  }
}
